import { CSVProfile, CSVTranformationProfile, IChartData, IDataPoint } from '../../types'
import { MwChartOneSeriesColumnOptions, SeriesData } from '@meltwater/mw-visualizations-angularjs'

import { BaseVisualization } from '../base/base-visualization-component'

export class VerticalBarChartComponent extends BaseVisualization {
 static config = {
  selector: 'verticalBarChart',
  controller: VerticalBarChartComponent,
  template: `
            <mw-chart-one-series-column
                ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData)"
                chart-data="$ctrl.visualizationData"
                chart-options="$ctrl.visualizationOptions"
                get-api="$ctrl.getApi(API)">
            </mw-chart-one-series-column>
    `,
  bindings: BaseVisualization.config.bindings,
 }

 public seriesColors
 public dataLabelFormatter
 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Category', 'Count']
 public transformationProfiles: CSVTranformationProfile[] = []

 $onInit() {}

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
   if (!this.isObjEmpty(changes.vizData.currentValue.data)) {
    this.setProperties()
    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
   } else {
    this.visualizationData = {}
   }
  }

  this.buildCSVExportProfile()
 }

 setProperties() {}

 updateData(data) {
  this.visualizationData = this.buildChartData(data.all)
 }

 updateOptions() {
  this.visualizationOptions = new MwChartOneSeriesColumnOptions(
   this.buildChartOptions(this.visualizationData.data)
  )
 }

 buildChartData(data: IDataPoint[]) {
  return new SeriesData({
   name: this.visTitle || 'Emotional comparison',
   data: data.map((x, index) => ({ ...x, color: this.seriesColors[index] })),
  })
 }

 tooltipFormatter = point => {
  return `<strong> ${point.key} </strong>: ${point.value}`
 }

 yAxisLabelFormatter = ({ value }) => `${value}`

 buildChartOptions(data: IDataPoint[]) {
  return {
   seriesColors: this.seriesColors,
   tooltipFormatter: this.tooltipFormatter,
   yAxisLabelFormatter: this.yAxisLabelFormatter,
   dataLabelFormatter: this.dataLabelFormatter,
  }
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
